<div class="playbook">
  <div class="back" (click)="clickOnBack()">
    <img class="back-img" src="assets/images/arrows/pagination-arrow.svg" (click)="clickOnBack()" />
    <div class="back-title">{{ backTitle }}</div>
  </div>

  <div class="title">{{ pageTitle }}</div>

  <div class="page">
    <div class="page-left">
      <div class="page-left-content">
        <div class="page-left-content-title">Step 1:</div>
        <div class="page-left-content-inputs" [formGroup]="fg">
          <div class="page-left-content-inputs-input">
            <div class="page-left-content-inputs-input-title">
              {{ 'zenityCommon.playbook' | labelsProvider }}
              {{ 'common.name' | labelsProvider }}
            </div>
            <input
              class="page-left-content-inputs-input-name"
              formControlName="name"
              type="text"
              [readOnly]="!hasPermisions"
              placeholder="{{ 'common.text_input_placeholder' | labelsProvider }}"
              [ngClass]="{
                'page-left-content-inputs-input-name-invalid':
                  (fg.controls['name'].invalid && fg.controls['name'].value?.length !== 0) ||
                  (fg.controls['name'].errors && fg.controls['name'].errors['required'] && submitAttempt),
              }"
            />
            @if (fg.controls['name'].invalid && fg.controls['name'].value?.length !== 0) {
              <div class="error-message">Maximum of {{ NAME_MAXIMUM_LENGTH }} characters is reached</div>
            }
          </div>

          <div class="page-left-content-inputs-input">
            <div class="page-left-content-inputs-input-title">
              {{ 'zenityCommon.integration' | labelsProvider }}
            </div>
            <app-select-v2
              [placeHolder]="'common.select' | labelsProvider"
              [options$]="integrationOptions$"
              (optionOnSelection)="integrationOnSelection($event)"
              [selectedId]="fg.controls['integration'].value"
              [disabled]="(playbookId !== null && !isCopy) || !hasPermisions"
              [valid]="integrationValid"
            >
            </app-select-v2>
          </div>

          <div class="page-left-content-inputs-input">
            <div class="page-left-content-inputs-input-title">
              {{ 'zenityCommon.policies' | labelsProvider }}
            </div>
            <app-multi-select
              [placeHolder]="'common.select' | labelsProvider"
              [options$]="policyOptions$"
              (optionOnSelection)="policiesOnSelection($event)"
              [selectedIds]="fg.controls['policies'].value || []"
              [disabled]="fg.controls['integration'].invalid || !hasPermisions || ((policiesDisabled | async) ?? false)"
              [valid]="policiesValid"
            >
            </app-multi-select>
          </div>

          <div class="page-left-content-inputs-input">
            <div class="page-left-content-inputs-input-title">
              {{ 'playbooks.status' | labelsProvider }}
            </div>
            <app-select-v2
              style="width: 100%"
              [placeHolder]="'common.select' | labelsProvider"
              [options$]="playbookStatusOptions$"
              [selectedId]="fg.controls['status'].value"
              [disabled]="!hasPermisions"
              (optionOnSelection)="statusOnSelection($event)"
            >
            </app-select-v2>
          </div>

          <div class="page-left-content-inputs-input">
            <div class="page-left-content-inputs-input-title">
              {{ 'playbooks.description' | labelsProvider }}
            </div>
            <textarea
              type="text"
              formControlName="description"
              placeholder="{{ 'common.description_input_placeholder' | labelsProvider }}"
              [readOnly]="!hasPermisions"
              [disabled]="!hasPermisions"
              [ngClass]="{
                'page-left-content-inputs-input-name-invalid': fg.controls['description'].invalid,
              }"
            ></textarea>
            @if (fg.controls['description'].invalid) {
              <div class="error-message">Maximum of {{ DESC_MAXIMUM_LENGTH }} characters is reached</div>
            }
          </div>

          @if (areBrownfieldPlaybooksEnabled) {
            <div class="page-left-content-card">
              <app-playbook-projection
                [trigger]="playbookTrigger"
                [policyIds]="fg.controls['policies'].value || []"
                [integrationId]="fg.controls['integration'].value"
              ></app-playbook-projection>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="page-right">
      <div class="page-right-content">
        <div class="page-right-content-title">
          Step 2: {{ 'playbooks.triggers' | labelsProvider }} & {{ 'playbooks.actions' | labelsProvider }}
        </div>
        <div class="page-right-triggers-actions">
          <div class="triggers">
            @if (!playbookTrigger || waitingForActionsResponse === 'new' || waitingForActionsResponse === 'edit') {
              <div
                class="triggers-empty"
                [ngClass]="{
                  'triggers-empty-invalid': !this.playbookTrigger && submitAttempt,
                }"
              >
                <div
                  class="triggers-empty-create"
                  (click)="openTrigger()"
                  [ngClass]="{
                    disabled:
                      fg.controls['platform'].invalid ||
                      fg.controls['integration'].invalid ||
                      !hasPermisions ||
                      waitingForActionsResponse === 'edit',
                  }"
                >
                  <img src="assets/images/common/create.svg" />
                  <div class="triggers-empty-create-title">
                    {{ 'common.add' | labelsProvider }} {{ 'playbooks.trigger' | labelsProvider }}
                  </div>
                </div>
              </div>
            }
            @if (
              playbookTrigger &&
              (waitingForActionsResponse === 'template' ||
                waitingForActionsResponse === 'success' ||
                waitingForActionsResponse === 'loading')
            ) {
              <div class="triggers-full">
                <div class="triggers-full-icon">
                  <img src="assets/images/common/trigger.svg" />
                </div>
                <div class="triggers-full-text">
                  <div class="triggers-full-text-name">
                    When: {{ playbookTrigger.triggerType | beautifyDisplayString }}
                    @if (tooltipTriggerDescription) {
                      <img
                        src="assets/images/notifications/info.svg"
                        alt="tooltip"
                        [matTooltip]="tooltipTriggerDescription | beautifyDisplayString"
                        matTooltipPosition="right"
                        matTooltipClass="long-text-tooltip-container"
                      />
                    }
                  </div>
                  <div class="triggers-full-text-description">
                    @if (generalTriggerDescription) {
                      <span>{{ generalTriggerDescription }}</span>
                    }
                  </div>
                </div>
                @if (hasPermisions) {
                  <div class="triggers-full-edit" (click)="openTrigger()">
                    <img src="assets/images/common/edit.svg" alt="edit" />
                  </div>
                }
              </div>
            }
          </div>

          @if (
            playbookTrigger &&
            (waitingForActionsResponse === 'template' ||
              waitingForActionsResponse === 'success' ||
              waitingForActionsResponse === 'loading')
          ) {
            <div class="page-right-triggers-actions-separator">
              <img src="assets/images/arrows/arrow-down.svg" alt="arrow-down" />
            </div>
          }

          <div class="actions">
            @if (
              playbookActions.length > 0 &&
              (waitingForActionsResponse === 'template' ||
                waitingForActionsResponse === 'success' ||
                waitingForActionsResponse === 'loading')
            ) {
              <div cdkDropList class="actions-full" (cdkDropListDropped)="drop($event)">
                @for (action of playbookActions; track action; let idx = $index) {
                  <div
                    class="actions-full-action"
                    [ngClass]="{
                      'invalid-action': !actionValidForTrigger(action) || !actionValuesAreValid(action),
                    }"
                    cdkDrag
                  >
                    <div class="actions-full-action-icon">
                      <img src="assets/images/common/play-without-border.svg" />
                    </div>
                    <div class="actions-full-action-name">
                      Then:
                      {{
                        action.actionType
                          | displayActionName: action.actionDefinitionProperties
                          | playbookActionTypeDisplayName
                      }}
                    </div>
                    @if (hasPermisions) {
                      <div class="actions-full-action-actions">
                        <img
                          class="actions-full-action-actions-edit"
                          (click)="waitingForActionsResponse !== 'loading' && openAction(idx)"
                          src="assets/images/common/edit.svg"
                        />
                        <img
                          class="actions-full-action-actions-delete"
                          src="assets/images/common/delete.svg"
                          (click)="removeAction(idx)"
                        />
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (
              hasPermisions &&
              (waitingForActionsResponse === 'template' ||
                waitingForActionsResponse === 'success' ||
                waitingForActionsResponse === 'loading')
            ) {
              <div
                class="actions-empty"
                [ngClass]="{ 'actions-empty-invalid': this.playbookActions.length === 0 && submitAttempt }"
              >
                @if (playbookTrigger && playbookActions.length < MAX_AMOUNT_OF_ACTIONS) {
                  <div
                    class="actions-empty-create"
                    (click)="waitingForActionsResponse !== 'loading' && openAction()"
                    [ngClass]="{
                      disabled:
                        !playbookTrigger ||
                        fg.controls['platform'].invalid ||
                        !hasPermisions ||
                        waitingForActionsResponse === 'loading',
                    }"
                  >
                    <img
                      [src]="
                        playbookTrigger && fg.controls['platform'].valid
                          ? 'assets/images/common/create.svg'
                          : 'assets/images/common/create-disabled.svg'
                      "
                    />
                    <div class="actions-empty-create-title">
                      {{ 'common.add' | labelsProvider }} {{ 'playbooks.action' | labelsProvider }}&nbsp;&nbsp;
                    </div>
                    @if (waitingForActionsResponse === 'loading') {
                      <mat-progress-spinner
                        [diameter]="18"
                        class="spinner"
                        color="white"
                        mode="indeterminate"
                      ></mat-progress-spinner>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons">
    <div
      class="confirm"
      [ngClass]="{
        'confirm-disabled':
          waitingForResponse || !hasPermisions || !fg.valid || waitingForActionsResponse !== 'success',
      }"
      (click)="createOrSave()"
      cdkFocusInitial
    >
      @if (!waitingForResponse) {
        <img src="assets/images/common/{{ playbookId ? 'save' : 'create' }}.svg" />
        <span>{{ playbookId && !isCopy ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
      }
      @if (waitingForResponse) {
        <mat-progress-spinner class="spinner" color="white" mode="indeterminate"></mat-progress-spinner>
      }
    </div>
  </div>
</div>
